import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
// eslint-disable-next-line jira/import-whitelist
import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { IssueTransitionOptInStatusGetResponse } from './IssueTransitionOptInStatusUpdateRequest.types.tsx';

const getDefaultIssueTransitionLabsOptInState = (): IssueTransitionOptInStatusGetResponse => {
	if (!fg('render-modern-issue-transition')) {
		return {
			isEnabled: false,
			expiryTime: -1,
		};
	}

	const isFedRampSrbFallback = fg('aem_migration_jira')
		? !isFeatureEnabled('jira', 'issue-transition-customisation-for-srb')
		: isFedRamp();

	const isModernIssueTransitionSRBCohort =
		fg('issue-transition-customisation-for-srb') || isFedRampSrbFallback;
	if (isModernIssueTransitionSRBCohort) {
		return {
			isEnabled: true,
		};
	}

	return expValEquals(
		'jira_issue_transition_screen_modernisation_toggle',
		'value',
		'BY_DEFAULT_USER_OPT_OUT',
	)
		? { isEnabled: false, expiryTime: -1 }
		: {
				isEnabled: true,
			};
};

export default getDefaultIssueTransitionLabsOptInState;
